@if (currentTask.status !== TaskStatusEnum.OPEN && currentTask.status !== TaskStatusEnum.LOCKED) {
  <div class="task-closed-banner">
    <mat-icon>lock</mat-icon>
    This task is <strong>{{ currentTask.status }}</strong>. The information below is read-only.
  </div>
}
@if (currentEnrollment && (currentTask.status === TaskStatusEnum.OPEN || currentTask.status === TaskStatusEnum.LOCKED)) {
  @for (m of unresolvedMatches; track m.propertyId) {
    <app-property-match-card [match]="m" [newIsManagementCompany]="newIsManagementCompany"
                             (link)="onLink(m, $event.newIsHome)" (notSame)="onNotSame(m)"></app-property-match-card>
  }
  @if (linkedMatch) {
    <div class="link-pending">
      <mat-icon>link</mat-icon>
      On approval this property will be linked with {{ linkedMatch.accountName }} ({{ pendingLink?.newIsHome ? 'this account' : linkedMatch.accountName }} carries the returns).
      <button mat-button type="button" (click)="clearLink()">Undo</button>
    </div>
  }
}
@if (currentEnrollment){
  <div class="column task-detail-container" [class.task-closed]="currentTask.status !== TaskStatusEnum.OPEN && currentTask.status !== TaskStatusEnum.LOCKED">
    @switch (currentEnrollment.enrollmentType) {
      @case (EnrollmentType.INDIVIDUAL_BED) {
        <app-individual-bed-enrollment [enrollment]="currentEnrollment"></app-individual-bed-enrollment>
      }
      @case (EnrollmentType.PROPERTY_MANAGEMENT) {
        <app-property-management-enrollment [enrollment]="currentEnrollment"></app-property-management-enrollment>
      }
      @case (EnrollmentType.INDIVIDUAL_OWNER) {
        <app-individual-owner-enrollment [enrollment]="currentEnrollment"></app-individual-owner-enrollment>
      }
      @default {
        <app-under-construction></app-under-construction>
      }
    }
  </div>
}
<app-task-action-bar [disabled]="disableSubmit" [approveDisabled]="matchesLoading || unresolvedMatches.length > 0" [currentTask]="currentTask" [saving]="saving"
                     (isTaskApproved)="isTaskApproved($event)" (save)="saveEdits()"></app-task-action-bar>
